export default {
    mn: "Minnesota: MNDOT/511MN",
    ia: "Iowa: Iowa DOT/511IA",
    wi: "Wisconsin: WisDOT/511WI",
    co: "Colorado: CDOT/COtrip",
    ks: "Kansas: KDOT/KanDrive",
    ne: "Nebraska: NDOT/Nebraska 511",
    ma: "Massachusetts: MassDOT/Mass511",
};
